import React from 'react';
import { Popover, Button, Spin, message, Modal, Input, Checkbox, Form, DatePicker } from 'antd';
import moment from 'moment';
import { thirdPartyOcrTypes, targetOcrTypes } from './enums';
import { getOcrVehicle, updateReportByOCR, checkMedicalRepeat } from '../../service/report';
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import './style.scss';

function getNumberFromEvent(event) {
    return event.target.value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
}

const format = 'YYYY-MM-DD';
export default class OCR extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lossers: props.lossers || [],
            selectedLosser: { lossId: '' },
            loading: false,
            isSuccessVisible: false,
            ocrResult: { time: undefined },
            selectedKeys: [],
            updateLoading: false
        }
        this.formRef = React.createRef();
    }

    static getDerivedStateFromProps(props, state) {
        if (props.lossers !== state.lossers) {
            return {
                lossers: props.lossers || []
            };
        }
        return null;
    }

    componentDidMount() {
        
     }

    // 点击识别，ocrType存放的是识别类型value
    recognize = async (item) => {
        const { loading } = this.state;
        const { imageId, imageUrl } = this.props;
        if (loading) {
            return
        }
        this.setState({
            selectedLosser: item,
            loading: true
        })
        try {
            const { result, vaildFail } = await getOcrVehicle(item.value, {
                flowId: this.props.flowId,
                lossId: item.lossId,
                lossType: item.lossType,
                imageUrl,
                imageId
            });
            if (vaildFail) {
                Modal.confirm({
                    zIndex: 2030,
                    title: '识别失败',
                    content: '照片识别失败，若照片分类无误可手动编辑。',
                    okText: '手动编辑',
                    onOk: () => {
                        this.setState({
                            ocrResult: {
                                ...result,
                                ocrLabel: item.label,
                                ocrType: item.value
                            },
                            selectedKeys: item.value === 'medical' ? item.columns.map(column => column.key) : [],
                            isSuccessVisible: true
                        }, () => {
                            this.formRef.current.setFieldsValue({
                                ...result,
                                time: result.time ? moment(result.time) : undefined
                            })
                        })
                        this.props.hideViewer && this.props.hideViewer();
                    },
                    onCancel() {
                        console.log('Cancel');
                    },
                });
                return
            }
            this.setState({
                isSuccessVisible: true,
                ocrResult: {
                    ...result,
                    ocrLabel: item.label,
                    ocrType: item.value
                },
                selectedKeys: item.value === 'medical' ? item.columns.map(column => column.key) : []
            }, () => {
                this.formRef.current.setFieldsValue({
                    ...result,
                    time: result.time ? moment(result.time) : undefined
                })
            })
            this.props.hideViewer && this.props.hideViewer();
        } catch (err) {
            console.log(err)
        }
        this.setState({
            loading: false
        })
    }
    // 勾选需更新的字段
    onCheckboxChange = event => {
        const { selectedKeys } = this.state;
        const { checked, name } = event.target;
        if (checked) {
            this.setState({
                selectedKeys: [...selectedKeys, name]
            })
        } else {
            this.setState({
                selectedKeys: selectedKeys.filter(item => item !== name)
            })
        }
    }

    // 获取标的/三者的ocr类型列表
    getOcrTypesByLosser = losser => {
        switch (losser.type) {
            case 'thirdParty':
                return thirdPartyOcrTypes.map((item) => ({ ...item, lossId: losser.lossId, lossType: losser.type }))
            case 'lossAssCar':
                return targetOcrTypes.map(item => ({ ...item, lossId: losser.lossId, lossType: losser.type }))
            default:
                return []
        }
    }

    renderLossers = () => {
        const { lossers, loading, selectedLosser } = this.state
        let index = 0;
        return lossers.map((losser) => {
            const { type } = losser;
            let lossType = '';
            if (type === 'thirdParty') {
                index++;
                lossType = `三者${index}`
            } else if (type === 'lossAssCar') {
                lossType = '标的'
            }
            const ocrTypes = this.getOcrTypesByLosser(losser);
            return <li
                key={losser.lossId}
            >
                <p>{lossType}({losser.name})</p>
                <ul className="ocr-types">
                    {ocrTypes.map((item) => (
                        <li key={losser.lossId + item.value} onClick={() => this.recognize(item)}>
                            {item.label}
                            <Spin
                                spinning={
                                    selectedLosser.value === item.value &&
                                    selectedLosser.lossId === item.lossId &&
                                    loading
                                }
                                size="small"
                                style={{ marginLeft: 5 }}
                            />
                        </li>
                    ))}
                </ul>
            </li>
        })
    }

    handleCancel = () => {
        this.setState({
            isSuccessVisible: false,
            selectedLosser: {}
        })
    }
    // 校验票据必填，校验发票的重复
    checkRepeat = async () => {
        try {
            const { ocrResult, selectedLosser, selectedKeys } = this.state;
            const formValues = this.formRef.current.getFieldsValue();
            // 发票识别，校验必填项目，转换日期格式
            if (!formValues.fapiaohao || !formValues.piaomianjine) {
                message.error('请先补充必填项')
                return;
            }
            let ocrData = selectedKeys.reduce((pre, cur) => ({
                ...pre,
                [cur]: formValues[cur]
            }), {});
            ocrData = {
                ...ocrData,
                time: formValues.time ? formValues.time.format(format) : '',
                imageId: ocrResult.imageId,
                url: ocrResult.url
            }
            this.setState({
                updateLoading: true
            })
            const { result } = await checkMedicalRepeat({
                flowId: this.props.flowId,
                lossId: selectedLosser.lossId,
                lossType: selectedLosser.lossType,
                data: ocrData,
            })
            // 若有重复，二次确认是否更新
            if (result.isRepeat) {
                this.setState({
                    updateLoading: false
                })
                Modal.confirm({
                    zIndex: 2030,
                    title: '同一发票号有重复数据！',
                    content: '同一发票号有重复数据，不能直接保存，请谨慎选择是更新数据，还是放弃？',
                    okText: '放弃',
                    cancelText: '更新',
                    cancelButtonProps: { danger: true },
                    onOk: () => {
                    },
                    onCancel: () => {
                        this.onUpdate();
                    },
                });
                return
            }
            this.onUpdate();
        } catch (err) {
            console.log(err)
            this.setState({
                updateLoading: false
            })
        }
    }
    // 更新识别信息
    onUpdate = async () => {
        try {
            const { selectedKeys, ocrResult, selectedLosser } = this.state;
            const formValues = this.formRef.current.getFieldsValue();
            let ocrData = selectedKeys.reduce((pre, cur) => ({
                ...pre,
                [cur]: formValues[cur]
            }), {});
            this.setState({
                updateLoading: true
            })
            if (ocrResult.ocrType === 'medical') {
                ocrData = {
                    ...ocrData,
                    time: formValues.time ? formValues.time.format(format) : '',
                    imageId: ocrResult.imageId,
                    url: ocrResult.url
                }
            }
            await updateReportByOCR(ocrResult.ocrType, {
                flowId: this.props.flowId,
                lossId: selectedLosser.lossId,
                lossType: selectedLosser.lossType,
                data: ocrData,
            })
            message.success('更新成功');
            this.handleCancel();
            this.props.onSuccess && this.props.onSuccess()
        } catch (err) {
            console.log(err)
        }
        this.setState({
            updateLoading: false
        })
    }
    // 识别编辑项校验是否需要更新
    getFormItem = column => {
        // 处理数字格式
        if (column.type === 'number') {
            return <Form.Item name={column.key} noStyle getValueFromEvent={getNumberFromEvent}>
                <Input disabled={column.disabled} />
            </Form.Item>
        }
        // 处理日期
        if (column.type === 'DatePicker') {
            return <Form.Item name={column.key} noStyle>
                <DatePicker disabled={column.disabled} popupStyle={{ zIndex: 2025 }} format={format} locale={locale} style={{ width: '100%' }} size="small" />
            </Form.Item>
        }
        return <Form.Item name={column.key} noStyle>
            <Input disabled={column.disabled} />
        </Form.Item>
    }
    // 监听Form表单数据变化
    onValuesChange = (changedValues, allValues) => {
        const { ocrResult } = this.state;
        const invoiceKeys = ['piaomianjine', 'tongchouzhifu', 'yileizifei', 'bingleizifei', 'fujiazhifu', 'qitakouchu', 'buhelikouchu'];
        // 票据明细识别时，判断是否有计算属性字段，并计算
        if (ocrResult.ocrType === 'medical') {
            if (Object.keys(changedValues).some(key => invoiceKeys.includes(key))) {
                // 票据明细，损失金额 = 票面金额-统筹支付-乙类自费-丙类自费-附加支付-其他扣除-不合理扣除。损失金额需要自动计算，公式中任一项变动均需即时计算；
                const { piaomianjine = 0, tongchouzhifu = 0, yileizifei = 0, bingleizifei = 0, fujiazhifu = 0, qitakouchu = 0, buhelikouchu = 0 } = allValues
                const sunshijine = ((piaomianjine * 100 - tongchouzhifu * 100 - yileizifei * 100 - bingleizifei * 100 - fujiazhifu * 100 - qitakouchu * 100 - buhelikouchu * 100) / 100).toFixed(2);
                this.formRef.current.setFieldsValue({
                    sunshijine
                })
            }
        }
    }
    render() {
        const { isSuccessVisible, selectedKeys, updateLoading, ocrResult, lossers, selectedLosser = {} } = this.state;
        const { columns = [] } = selectedLosser;
        return (
            <React.Fragment>
                <Popover
                    overlayClassName="ocr-popover"
                    zIndex="2016"
                    placement="topLeft"
                    overlayStyle={{ left: 0, bottom: 0 }}
                    trigger="hover"
                    getPopupContainer={() =>
                        document.querySelector('.viewer-container') || document.body
                    }
                    content={
                        <div className="ocr-pop-content">
                            <ul
                                className="lossers-list"
                                style={{ minHeight: lossers.length < 5 ? 180 : 0 }}
                            >
                                {this.renderLossers()}
                            </ul>
                        </div>
                    }
                    title={null}
                >
                    <Button shape="circle" size="small"><i className="iconfont icon-scan" /></Button>
                </Popover>
                <Modal
                    title={null}
                    visible={isSuccessVisible}
                    onCancel={this.handleCancel}
                    footer={[<Button type="primary" onClick={ocrResult.ocrType === 'medical' ? this.checkRepeat : this.onUpdate} disabled={!selectedKeys.length} loading={updateLoading}>使用勾选项</Button>]}
                    className="ocr-modal"
                    width={900}
                    zIndex={2020}
                    maskClosable={false}
                >
                    <div className="ocr-modal-container">
                        <div className="ocr-img">
                            <img src={ocrResult.url} />
                        </div>
                        <div className="ocr-list">
                            <h4 className="ocr-list-title">{ocrResult.ocrLabel}结果</h4>
                            <dl className="ocr-list-content">
                                <dt>
                                    <span>字段</span>
                                    <span>内容</span>
                                    <span>勾选</span>
                                </dt>
                                {/* 识别结果存放在Form中，其余只做展示 */}
                                <Form ref={this.formRef} onValuesChange={this.onValuesChange} size="small">
                                    {
                                        columns.map(column => <dd key={column.key}>
                                            <div>{column.name}{column.required ? <em>*</em> : null}</div>
                                            <div className={column.disabled ? 'disabled' : ''}>
                                                {/* 医疗票据里的sunshijine需进行数据监听 */}
                                                {
                                                    column.editable ? this.getFormItem(column) : <span style={{ color: '#999' }}>{ocrResult[column.key]}</span>
                                                }
                                            </div>
                                            <div>
                                                {
                                                    column.editable ? <Checkbox checked={selectedKeys.includes(column.key)} name={column.key} onChange={this.onCheckboxChange} disabled={ocrResult.ocrType === 'medical'} /> : null
                                                }
                                            </div>
                                        </dd>)
                                    }
                                </Form>
                            </dl>
                        </div>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}
